import store from "@/store";
let detailOrigin = process.env.VUE_APP_OLD_DETAIL_URL;
let reqParams = store.state.search.searchParams;
/**
 * 详情页Url
 * @param id
 * @param catid
 * @constructor
 */
export function DetailUrlFilter(id, catid, keywords, other) {
  let pageName = detailOrigin;
  switch (catid) {
    case 301:
    case 601:
      pageName += `/tenderDetail.html`;
      break;
    case 202:
      pageName += `/projectDetail.html`;
      break;
    case 201:
      pageName += `/tenderDetail.html`;
      break;
    case 101:
      pageName += `/projectDetail.html`;
      break;
    case 2703:
      pageName += `/companyAnalyse.html`;
      break;
    default:
      pageName += `/tenderDetail.html`;
      break;
  }
  if (catid === 2703) {
    return pageName;
  } else {
    try {
      let { currentPage, batchNo, tenderOrBidderName } = reqParams;
      pageName += `?id=${id}`;
      if (!keywords) {
        keywords = reqParams.keywords;
      }
      // 搜索关键词
      if (keywords) {
        pageName += `&keywords=${encodeURIComponent(keywords)}`;
        // vip 在搜索结果中搜索关键词
        if (tenderOrBidderName) {
          pageName += `,${tenderOrBidderName}`;
        }
      }
      // 埋点批次号
      if (batchNo) {
        pageName += `&batchNo=${batchNo}`;
      }
      // 埋点搜索页面
      if (currentPage) {
        pageName += `&currentPage=${currentPage}`;
      }
      if (other) {
        pageName += other;
      }
    } catch (e) {
      console.log(e);
    }
    // 埋点搜索开始时间(有问题，应为：详情页浏览开始时间)
    // pageName += `&viewStime=${new Date().getTime()}`;
    return pageName;
  }
}
export function getDetailUrl(id, catid, other) {
  let pageName = detailOrigin;
  switch (catid) {
    case 301:
    case 601:
      pageName += `/tenderDetail.html`;
      break;
    case 202:
      pageName += `/projectDetail.html`;
      break;
    case 201:
      pageName += `/tenderDetail.html`;
      break;
    case 101:
      pageName += `/projectDetail.html`;
      break;
    case 2703:
      pageName += `/companyAnalyse.html`;
      break;
    case 501:
      pageName += `/purchaseIntentionDetail.html`;
      break;
    default:
      pageName += `/tenderDetail.html`;
      break;
  }
  if (catid === 2703) {
    return pageName;
  } else {
    pageName += "?id=" + id;
    other ? (pageName += other) : "";
  }
  return pageName;
}
